import React from 'react'
import { useHistory } from 'react-router-dom'

// componets
import Avatar from '../../components/avator/Avatar'

// hooks
import { useFireStore } from '../../Hooks/useFireStore'
import { useAuthContext } from '../../Hooks/useAuthContext'

export default function ProjectSummary({ project}) {
  const { deleteDocument } = useFireStore('projects')
  const { user } = useAuthContext ()
   const history = useHistory()

  const handleClick = () => {
    deleteDocument(project.id)
    history.push('/')
  } 

  return (
    <div>
        <div className="project-summary">
            <h2 className='page-title'>{project.name}</h2>
            <div className="comment-author">
                <small>By: {project.createdBy.displayName}</small> 
            </div>
            <small>Category: {project.category}</small> <br />
            <small className="due-date">Project due date - {project.dueDate.toDate().toDateString() }</small>
            <hr />
            <p className="details">{project.details}</p>
            <hr />
            <h4>Assigned to:</h4>
            <div className="assigned-users">
                {project.assignedUsersList.map(user => (
                    <div key={user.id}><Avatar image={user.photoURL} /> </div>
                ))}
            </div>
            
        </div>
        { user.uid === project.createdBy.id && (
          <button className='btn' onClick={handleClick}>Mark as complete</button>
        )}
    </div>
  )
}
